import * as React from 'react';

import type {
  UseCurriculum_DegreeCurriculumFragment as DegreeCurriculumFragment,
  UseCurriculum_PbaCurriculumFragment as PbaCurriculumFragment,
} from 'bundles/degree-home/components/v3-dpm/lib/__queries__/__generated__/useCurriculum';

type CurriculumDataContextType = {
  curriculum: DegreeCurriculumFragment | PbaCurriculumFragment | null;
};

const CurriculumDataContext = React.createContext<CurriculumDataContextType>({ curriculum: null });

export const useCurriculumDataContext = () => {
  const context = React.useContext(CurriculumDataContext);
  if (context === undefined) {
    throw new Error('useCurriculumDataContext must be used within CurriculumDataContext');
  }
  return context;
};

type Props = {
  curriculum: DegreeCurriculumFragment | PbaCurriculumFragment;
};

const CurriculumDataContextProvider: React.FC<Props> = ({ curriculum, children }) => {
  return <CurriculumDataContext.Provider value={{ curriculum }}>{children}</CurriculumDataContext.Provider>;
};

export default CurriculumDataContextProvider;
